"use client";

import { Field as FieldPrimitive } from "@base-ui/react/field";
import type React from "react";
import { cn } from "@/utils/class-name";

export function Field({ className, ...props }: FieldPrimitive.Root.Props): React.ReactElement {
    return (
        <FieldPrimitive.Root
            data-slot={"field"}
            className={cn("flex flex-col items-start gap-2", className)}
            {...props}
        />
    );
}

export function FieldLabel({ className, ...props }: FieldPrimitive.Label.Props): React.ReactElement {
    return (
        <FieldPrimitive.Label
            data-slot={"field-label"}
            className={cn(
                "inline-flex items-center gap-2 text-control/4 text-foreground data-disabled:opacity-55",
                className,
            )}
            {...props}
        />
    );
}

export function FieldItem({ className, ...props }: FieldPrimitive.Item.Props): React.ReactElement {
    return <FieldPrimitive.Item className={cn("flex", className)} data-slot={"field-item"} {...props} />;
}

export function FieldDescription({ className, ...props }: FieldPrimitive.Description.Props): React.ReactElement {
    return (
        <FieldPrimitive.Description
            data-slot={"field-description"}
            className={cn("text-xs text-muted-foreground", className)}
            {...props}
        />
    );
}

export function FieldError({ className, ...props }: FieldPrimitive.Error.Props): React.ReactElement {
    return (
        <FieldPrimitive.Error
            data-slot={"field-error"}
            className={cn("text-xs text-destructive", className)}
            {...props}
        />
    );
}

export const FieldControl: typeof FieldPrimitive.Control = FieldPrimitive.Control;
export const FieldValidity: typeof FieldPrimitive.Validity = FieldPrimitive.Validity;

export { FieldPrimitive };
